import type {CHeliPositionChannel} from './CHeliPositionChannel';
import type {IHeliNetError} from './IHeliNetError';

export class CHeliPosChannelList implements IHeliNetError {
  m_position_channels: Array<CHeliPositionChannel>;
  m_offset: number;
  m_limit: number | null;
  m_errorCode: string | null = null;
  m_errorData: unknown = null;

  constructor(
    postion_channels: Array<CHeliPositionChannel> = [],
    offset: number = 0,
    limit: number | null = null
  ) {
    this.m_position_channels = postion_channels;
    this.m_offset = offset;
    this.m_limit = limit;
  }

  getList(): Array<CHeliPositionChannel> {
    return this.m_position_channels.slice(
      this.m_offset,
      this.m_limit !== null ? this.m_offset + this.m_limit : undefined
    );
  }

  setError({code, data}: {code: string | null; data: unknown}) {
    this.m_errorCode = code;
    this.m_errorData = data;
  }

  getErrorCode(): string | null {
    return this.m_errorCode;
  }

  getErrorData(): unknown {
    return this.m_errorData;
  }

  isValid() {
    return this.m_errorCode === null && this.m_errorData === null;
  }
}
